import Swiper from "swiper/bundle";

import 'swiper/css/bundle';

export default () => {
    const swiper01 = new Swiper('.swiper01', {
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 2.5,
        spaceBetween: 100,
        centeredSlides: true,
        breakpoints: {
            768: {
                spaceBetween: 200,
            }
        },
        speed: 8000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: true,
        },
    });

};
